import React, { useEffect, useState } from 'react'
import { autorun } from 'mobx'

// evertel
import { useService } from '@evertel/di'
import { UserController } from '@evertel/blue-user'
import TextReadWidget from './TextWidget'

interface UserReadWidgetProps {
    value?: number
    title?: string
    description?: string
    contentType?: 'text' | 'url' | 'email'
}

const UserReadWidget: React.FC<UserReadWidgetProps> = ({
    value: userId,
    ...otherProps
}) => {

    const userController = useService(UserController, [])
    const [fullName, setFullName] = useState('')

    useEffect(() => {
        // userController is fine since it doesn't fetch user, only gets from store
        // but the user must be in store since they viewed the document to get the pdf
        if (userId) {
            userController.init(userId)

            const dispose = autorun(() => {
                setFullName(userController.fullName ?? userController.user?.email)
            })

            return () => dispose()
        }
    }, [userId, userController])

    if (!userId) return null

    return (
        <TextReadWidget
            value={fullName}
            {...otherProps}
        />
    )
}

export default UserReadWidget
